export const SOCIAL_URLS = {
	LINKED_IN: {
		name: 'LinkedIn',
		url: 'https://www.linkedin.com/in/thomas-chestnut/',
	},
	GITHUB: { name: 'GitHub', url: 'https://github.com/tchestnut85' },
	STACK_OVERFLOW: {
		name: 'Stack Overflow',
		url: 'https://stackoverflow.com/users/13815310/tchestnut85',
	},
	TWITTER: { name: 'Twitter', url: 'https://twitter.com/tchestnut28' },
	HACKER_RANK: {
		name: 'HackerRank',
		url: 'https://www.hackerrank.com/tchestnut85',
	},
};
